import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

const routes = (): RouteRecordRaw[] => {
  return [
    {
      component: () => import('./pages/create-label/CreateLabel.vue'),
      name: ROUTE_NAMES.SHIPPING.CREATE_LABEL,
      path: '/bo-seller/shipping/create-label',
      meta: {
        owners: ['bot-squad-seller-experience-front'],
      },
    },
  ]
}

export default routes
